export const complaintInboxTags = {
  0: // User Inbox - sees closed complaints (for potential escalation)
    [
      "compl_closed_by_supv",
      "compl_closed_by_l1"
    ],

  1: // Support Staff Inbox
    [
      "complaint_created",
      "fwd_reaasign_ss",
      "fwd_to_oldss_foraction",
      "compl_on_hold"
    ],

  2: // Supervisor Inbox - receives from SupportStaff for closure + from L1Support for action
    [
      "fwd_supv_fr_close",
      "l1_fwd_sup_foraction"
    ],

  3: // Supervisor All Complaints - no specific tags, filtered by store only
    [],

  4: // L1Support - receives user escalations and supervisor resolutions
    [
      "escalated_to_l1",
      "supv_resolved_fwd_l1"
    ],

  5: // L2Support - same tags as L1Support (backup role)
    [
      "escalated_to_l1",
      "supv_resolved_fwd_l1"
    ]
}
